import React, { useCallback, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { KpiIcon } from "../../../../DataManagment/Quantative/component/KpiIcons";

const RowActionMenu = ({ menuId, openMenuId, setOpenMenuId, items = [] }) => {
  const triggerRef = useRef(null);
  const menuRef = useRef(null);
  const open = openMenuId === menuId;
  const [menuStyle, setMenuStyle] = useState(null);

  const updateMenuPosition = useCallback(() => {
    if (!triggerRef.current) return;
    const rect = triggerRef.current.getBoundingClientRect();
    setMenuStyle({
      position: "fixed",
      top: rect.bottom + 4,
      right: window.innerWidth - rect.right,
      minWidth: 200,
      zIndex: 10000,
    });
  }, []);

  useEffect(() => {
    if (!open) {
      setMenuStyle(null);
      return undefined;
    }
    updateMenuPosition();
    window.addEventListener("scroll", updateMenuPosition, true);
    window.addEventListener("resize", updateMenuPosition);
    return () => {
      window.removeEventListener("scroll", updateMenuPosition, true);
      window.removeEventListener("resize", updateMenuPosition);
    };
  }, [open, updateMenuPosition]);

  useEffect(() => {
    if (!open) return undefined;
    const onDocClick = (e) => {
      const inTrigger = triggerRef.current?.contains(e.target);
      const inMenu = menuRef.current?.contains(e.target);
      if (!inTrigger && !inMenu) {
        setOpenMenuId(null);
      }
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [open, setOpenMenuId]);

  if (!items.length) return null;

  const menuPortal =
    open && menuStyle
      ? createPortal(
        <div ref={menuRef} className="kpi-dropdown-menu" style={menuStyle}>
          {items.map((item) => (
            <div
              key={item.key}
              role="button"
              tabIndex={0}
              className={`kpi-dropdown-item${item.danger ? " danger" : ""}`}
              onClick={(e) => {
                e.stopPropagation();
                setOpenMenuId(null);
                item.onClick?.();
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  setOpenMenuId(null);
                  item.onClick?.();
                }
              }}
            >
              {item.icon ? <KpiIcon name={item.icon} size={14} /> : null}
              <span>{item.label}</span>
            </div>
          ))}
        </div>,
        document.body
      )
      : null;

  return (
    <>
      <div
        ref={triggerRef}
        style={{
          position: "relative",
          display: "inline-flex",
          justifyContent: "center",
        }}
      >
        <button
          type="button"
          className="kpi-action-btn"
          aria-label="Actions"
          aria-expanded={open}
          title="Actions"
          onClick={(e) => {
            e.stopPropagation();
            setOpenMenuId(open ? null : menuId);
          }}
        >
          <KpiIcon name="dots" size={16} />
        </button>
      </div>
      {menuPortal}
    </>
  );
};

export default RowActionMenu;
